import { ShareStepsLayout } from "@rapid/components/layout/StepsLayout";

export function ShareLayout({
    Sidebar,
    VisualArea,
    BottomContent
}: {
    Sidebar?: React.ReactNode;
    VisualArea: React.ReactNode;
    BottomContent?: React.ReactNode;
}) {
    // Share layout uses ShareStepsLayout which removes flow stepper and sidebar, adds gradient background
    return <ShareStepsLayout VisualArea={VisualArea} BottomContent={BottomContent} />;
}
